require("./visualMapContinuous");

require("./visualMapPiecewise");


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/visualMap.js
// module id = 810
// module chunks = 2